"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFlatFilters = void 0;
var _filters = require("../filters");
var _types = require("../filters/types");
var _validateAddressWeb = require("../../shared/repositories/price-estimator/v1/validate-address-web");
var _selectors = require("../../selectors");
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Валидатор фильтров для типа оцениваемой недвижимости "Квартиры"
 * Проверяет наличие обязательных полей, соответствие их условиям
 * Отправляет запрос к АПИ, валидируя адрес
 * */
const validateFlatFilters = () => async (dispatch, getState, context) => {
  const state = getState();
  const {
    address,
    area,
    roomsCount,
    flatNumber,
    myHome
  } = (0, _selectors.selectFilters)(state);
  if (!address) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.address,
      errorText: 'Укажите адрес'
    }));
    return false;
  }
  if (!flatNumber && myHome?.withRoomNumber) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.flatNumber,
      errorText: 'Укажите квартиру'
    }));
    return false;
  }
  if (!roomsCount) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.roomsCount,
      errorText: 'Укажите кол-во комнат'
    }));
    return false;
  }
  if (!area) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.area,
      errorText: 'Укажите площадь'
    }));
    return false;
  }
  if (area > 1000) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.area,
      errorText: 'Недопустимое значение'
    }));
    return false;
  }
  try {
    const response = await (0, _validateAddressWeb.fetchValidateAddressWeb)({
      httpApi: context.httpApi,
      parameters: {
        address
      }
    });
    if (response.statusCode === 400) {
      const errors = response.response.errors || [];
      const error = errors[0] || {};
      const {
        key,
        message
      } = error;
      if (key && message) {
        dispatch((0, _filters.setError)({
          currentErrorField: key,
          errorText: message
        }));
      }
      return false;
    }
  } catch (e) {
    context.logger.error('Unable to validate flat address', e);
    return false;
  }
  return true;
};
exports.validateFlatFilters = validateFlatFilters;